import "./markedText.scss";
import Circle from "../SVG/Circle";
import Underline from "../SVG/Underline";

import CircleLong from "../SVG/CircleLong";
import UnderlineSmall from "../SVG/UnderlineSmall";

type MTProps = {
  startText?: string;
  circleText?: string | undefined;
  middelText?: string;
  underlinedText?: string;
  endText?: string;
  handwritten?: string;
  className?: string;
  isSmall: boolean;
  center: boolean;
};

const MarkedText = ({
  startText,
  circleText,
  middelText,
  underlinedText,
  endText,
  handwritten,
  isSmall,
  center,
  className,
}: MTProps) => {
  const circleSize = () => {
    if (circleText) {
      if (circleText?.length < 5) {
        return (
          <div className="circle">
            <Circle />
          </div>
        );
      } else {
        return (
          <div className="circle long">
            <CircleLong />
          </div>
        );
      }
    }
  };
  const underlineSize = () => {
    if (underlinedText?.length < 5) {
      return (
        <div className="underline">
          <UnderlineSmall />
        </div>
      );
    } else {
      return (
        <div className="underline">
          <Underline />
        </div>
      );
    }
  };

  return (
    <div
      className={`${className} marked-text ${center ? "center" : ""} ${
        isSmall ? "small" : "big"
      }`}
    >
      {startText && <> {startText}&nbsp;</>}
      {circleText && (
        <span className="circle-text">
          {circleText}&nbsp;
          {circleSize()}
        </span>
      )}
      {middelText && <>{middelText}&nbsp;</>}
      {underlinedText && (
        <span className="underline-text">
          {underlinedText}&nbsp;
          {underlineSize()}
        </span>
      )}
      {endText ? `${endText}` : ""}
      {handwritten ? <span className="handwritten"> {handwritten}</span> : ""}
    </div>
  );
};
export default MarkedText;
